module.exports = __webpack_public_path__ + "media/images/seguro-icon-fa8bf55abea028fc6fcbfe553341d3bf.svg";